import { Component, inject, Input } from '@angular/core';
import { Router } from '@angular/router';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { AlertComponent, ButtonComponent, ISelect, LinkComponent, TileComponent } from '@tecalisdev/infinity';
import { environment } from '../../../../environments/environment';
import { SnackbarService } from '../../../shared/services/snackbar.service';
import { ModalCreateProcessComponent } from '../../../processes/components/modal-create-process/modal-create-process.component';
import { RolePermissionsService } from '../../../core/services/role-permissions.service';
import { IWorkflowDetailResponse } from '../../models/workflows.models';

@Component({
	selector: 'app-workflow-ready',
	imports: [
		TranslatePipe,
		TileComponent,
		ButtonComponent,
		LinkComponent,
		AlertComponent,
		ModalCreateProcessComponent,
	],
	templateUrl: './workflow-ready.component.html',
	styleUrl: './workflow-ready.component.scss',
})
export class WorkflowReadyComponent {
	private router = inject(Router);
	private snackbarService = inject(SnackbarService);
	private trans = inject(TranslateService);
	private rolePermissions = inject(RolePermissionsService);

	@Input() data?: { id: string; type: 'create' | 'update'; value?: IWorkflowDetailResponse };

	public integrationUrl?: string = environment?.integrationUrl;
	public isProduction?: boolean = environment?.production;
	public workflow?: ISelect;

	public edit(): void {
		if (!this.data?.id) return;

		const id = this.data?.id;
		const target = `/workflows/edit/${id}`;
		if (this.router.url === target) {
			// Si ya estamos en la misma ruta, forzar un recargo navegando fuera
			// y luego regresando sin cambiar el historial del navegador.
			this.router
				.navigateByUrl('/', { skipLocationChange: true })
				.then(() => this.router.navigate(['workflows', 'edit', id]));
		} else {
			this.router.navigate(['workflows', 'edit', id]);
		}
	}

	public testWorkflow(): void {
		if (!this.data?.id || !this.rolePermissions.canLaunchWorkflowDemo()) return;

		this.workflow = {
			id: this.data?.id,
			label: this.data?.value?.alias,
			value: this.data?.value,
		};
	}

	public skipTest(): void {
		this.router
			.navigate(['workflows'])
			.then(() =>
				this.snackbarService.show(
					this.trans.instant(`WORKFLOWS.FORM.${this.data?.type === 'create' ? 'CREATE' : 'UPDATE'}_OK`),
				),
			);
	}
}
